import { RECAPTCHA_SITE_KEY } from "../../constants";

/**
 * Action types
 * @property {string} RECAPTCHA_LOADED
 * @property {string} RECAPTCHA_LOADING
 */
export const types = {
  RECAPTCHA_LOADED: "RECAPTCHA_LOADED",
  RECAPTCHA_LOADING: "RECAPTCHA_LOADING",
};

/**
 * @namespace Reducers
 */
export const reducers = {
  /**
   * Updates reCaptcha loaded state
   * @param {object} state
   * @param {object} action
   * @param {string} action.type
   * @memberof Reducers
   */
  recaptchaLoaded: (state = false, action) => {
    switch (action.type) {
      case types.RECAPTCHA_LOADED:
        return true;
      default:
        return state;
    }
  },

  /**
   * Updates reCaptcha loading state
   * @param {object} state
   * @param {object} action
   * @param {string} action.type
   * @memberof Reducers
   */
  recaptchaLoading: (state = false, action) => {
    switch (action.type) {
      case types.RECAPTCHA_LOADED:
        return false;
      case types.RECAPTCHA_LOADING:
        return true;
      default:
        return state;
    }
  },
};

/**
 * @namespace Actions
 */
export const actions = {
  /**
   * Request reCaptcha token
   * @param {string} action
   * @memberof Actions
   */
  execute: action => dispatch => {
    return new Promise((resolve, reject) => {
      if (!window.grecaptcha || !RECAPTCHA_SITE_KEY) {
        reject("not defined");
      }

      try {
        window.grecaptcha
          .execute(RECAPTCHA_SITE_KEY, { action: action })
          .then(token => {
            resolve(token);
          });
      } catch (error) {
        reject(error.message || "reCaptcha error");
      }
    });
  },

  /**
   * Handle reCaptcha loaded event
   * @memberof Actions
   */
  handleLoaded: () => ({
    type: types.RECAPTCHA_LOADED,
  }),

  /**
   * Handle reCaptcha loading event
   * @memberof Actions
   */
  handleLoading: () => ({
    type: types.RECAPTCHA_LOADING,
  }),
};
